import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {action, observable, toJS} from 'mobx';
import ReactPlayer from 'react-player';
import appStore from '../../containers/app/store';
import './styles.scss';
import {isFB, isSafari} from "../../utils/screenUtility";
import {customEvent} from "../../utils/analyticsUtil";
import {category, events} from "../../constants/enums";

const config = {
    file: {
        attributes: {
            preload: 'metadata',
            controlsList: 'nodownload',
            disablePictureInPicture: true
        }
    }
};

@observer
class VideoPlayer extends Component {
    @observable videoLoading = true;
    @observable tryIframe = false;

    @action setVideoLoading = (val) => {
        this.videoLoading = val;
    };

    handleVideoReady = (e) => {
        this.setVideoLoading(false);
        if (this.props.onReady) this.props.onReady(e);
    };

    @action handleVideoError = (e) => {
        if (e === 150) {
            return;
        }
        this.tryIframe = true;
    };

    iframeError = (e) => {
        this.setVideoLoading(false);
        if (this.props.onError) this.props.onError(e);
        appStore.createAlertFromMessageId('error', 'Video Error Message');
    };

    @action componentDidUpdate(prevProps) {
        if (prevProps.url !== this.props.url) {
            this.tryIframe = false;
        }
    }

    onPlay = () => {
        customEvent(events.CustomEvent, {category: category.PlayVideo})
    }

    render() {
        const {url, title, light = false, controls = true, playing = true, onEnded, poster} = this.props;
        let urlArray = toJS(url);
        let firstUrl = Array.isArray(urlArray) && urlArray.length > 0 ? urlArray.filter(u => !u.match(/converted/))[0] : urlArray;

        console.log(urlArray);
        if (isSafari() && Array.isArray(urlArray)) {
            urlArray = urlArray.map(u => {
                return u + '#t=0.1'
            });
        }

        if (isFB() && poster) {
            config.file.attributes.poster = poster;
        }

        return (
            <div className={`video-wrapper ${this.videoLoading && !light ? 'in-progress' : ''}`}>
                {/* {this.videoLoading && thumbnail && !light && <div className="circular-loader" />} */}
                {title && <div className="video-title">{title}</div>}
                {this.tryIframe && <video title="video" className="video-player-iframe" controls onError={this.iframeError}>
                    <source src={urlArray[0]}/>
                    {urlArray.length > 1 && <source src={urlArray[1]}/>}
                </video>}
                {!this.tryIframe && <ReactPlayer
                    className="video-player"
                    url={urlArray}
                    onError={this.handleVideoError}
                    onReady={this.handleVideoReady}
                    controls={controls}
                    light={light}
                    playing={playing}
                    width="100%"
                    height="100%"
                    onEnded={onEnded}
                    config={config}
                    onPlay={this.onPlay}
                    onPause={this.onPause}
                />}
            </div>
        );
    }
}

VideoPlayer.propTypes = {
    url: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired]),
    light: PropTypes.bool,
    controls: PropTypes.bool,
    playing: PropTypes.bool,
    thumbnail: PropTypes.bool,
    title: PropTypes.any,
    onError: PropTypes.func,
    onReady: PropTypes.func
};

export default VideoPlayer;
